import { InjectionToken } from '@angular/core';

const DEFAULT_REPORTING_API_CR_DEV = 'https://reportingapi-cr-271585780604.us-central1.run.app';
const DEFAULT_REPORTING_API_CR_PROD = 'https://reportingapi-cr-1088177355571.us-central1.run.app';
const DEFAULT_REPORTING_API_EMULATOR_URL_LOCAL = 'http://reports-local.localhost';
const DEFAULT_REPORTING_API_EMULATOR_URL_REMOTE = 'http://reports-remote.localhost';

export enum ReportingApiTarget {
  CloudRun = 'cloud-run',
  LocalApi = 'local-api',
}

export enum ReportingApiCloudRunMode {
  Common = 'common',
  PreviewAuto = 'preview-auto',
  PreviewTagged = 'preview-tagged',
}

export enum ReportingApiLocalApiMode {
  LocalDb = 'local-db',
  RemoteDb = 'remote-db',
}

export interface ReportingApiCloudRunConfig {
  target: ReportingApiTarget.CloudRun;
  cloudRun: {
    url: string;
    mode: ReportingApiCloudRunMode;
    taskId: string | null;
  };
}

export interface ReportingApiLocalApiConfig {
  target: ReportingApiTarget.LocalApi;
  localApi: {
    mode: ReportingApiLocalApiMode;
    urls: {
      localDb: string;
      remoteDb: string;
    };
  };
}

export type ReportingApiConfig = ReportingApiCloudRunConfig | ReportingApiLocalApiConfig;
export type ReportingApiEnvironmentConfig = ReportingApiConfig;

export const REPORTING_API_CONFIG = new InjectionToken<ReportingApiConfig>('REPORTING_API_CONFIG');

export const REPORTING_API_CLOUD_RUN_URL_DEV = DEFAULT_REPORTING_API_CR_DEV;
export const REPORTING_API_CLOUD_RUN_URL_PROD = DEFAULT_REPORTING_API_CR_PROD;
export const REPORTING_API_LOCAL_API_URLS: ReportingApiLocalApiConfig['localApi']['urls'] = {
  localDb: DEFAULT_REPORTING_API_EMULATOR_URL_LOCAL,
  remoteDb: DEFAULT_REPORTING_API_EMULATOR_URL_REMOTE,
};
